const GRADE_KEYS = ['EXCELLENT', 'GOOD', 'AVERAGE', 'BAD', 'POOR'];

const gradeFromNumber = (value) => {
	if (Number.isNaN(value)) return 'POOR';
	if (value >= 95) return 'EXCELLENT';
	if (value >= 85) return 'GOOD';
	if (value >= 75) return 'AVERAGE';
	if (value >= 65) return 'BAD';
	return 'POOR';
};

export const resolveScoreGrade = (score, fallbackResult) => {
	if (score != null && score !== '') {
		const upper = String(score).trim().toUpperCase();
		if (GRADE_KEYS.includes(upper)) {
			return upper;
		}

		const numericScore = parseFloat(score);
		if (!Number.isNaN(numericScore)) {
			return gradeFromNumber(numericScore);
		}
	}

	if (fallbackResult != null && fallbackResult !== '') {
		return gradeFromNumber(parseFloat(fallbackResult));
	}

	return 'POOR';
};

export const scoreClassFor = (score, fallbackResult) => {
	const map = {
		EXCELLENT: 'chip-score-excellent',
		GOOD: 'chip-score-good',
		AVERAGE: 'chip-score-average',
		BAD: 'chip-score-bad',
		POOR: 'chip-score-poor',
	};

	return map[resolveScoreGrade(score, fallbackResult)] || 'chip-score-poor';
};

export const scoreLabelFor = (score) => {
	if (score == null || score === '') return '-';
	return String(score).trim();
};

/** BAD & POOR: reason wajib (min 10 words); attachment optional.
 * - Supplier SPBI acknowledge: tampil di Outstanding/waiting confirm.
 * - Purchasing Pending CAPA Proxy: tampil editable; Pending CAPA: disembunyikan.
 * - Purchasing History Confirm Proxy (Excellent/Good/Average, Sent, non-portal):
 *   reason + attachment ditampilkan opsional (editable); Completed: disabled/read-only.
 * EXCELLENT / GOOD / AVERAGE: reason + attachment tidak ditampilkan di supplier.
 */
export const ACKNOWLEDGE_REASON_MIN_LENGTH = 10;

export const requiresAcknowledgeReason = (supplierScore, totalResult) => {
	const grade = resolveScoreGrade(supplierScore, totalResult);
	return grade === 'BAD' || grade === 'POOR';
};

export const requiresAcknowledgeAttachment = (supplierScore, totalResult) =>
	requiresAcknowledgeReason(supplierScore, totalResult);

/** @deprecated gunakan requiresAcknowledgeReason */
export const requiresAcknowledgeEvidence = (supplierScore, totalResult) =>
	requiresAcknowledgeReason(supplierScore, totalResult);

/** @deprecated gunakan requiresAcknowledgeReason */
export const isPoorSupplierScore = (supplierScore, totalResult) =>
	requiresAcknowledgeReason(supplierScore, totalResult);
